<template>
  <div>
    <div class="level">
      <div class="level-left">
        <h3 class="title is-3">Attendance Logs</h3>
      </div>
      <div class="level-right">
        <button :class="isSendingBulkTimesheet" @click="sendBulkTimesheets">
          Send bulk timesheets by current cut-off
        </button>
      </div>
    </div>
    <hr />
    <!-- <button class="button is-info is-small" @click="syncLogs">Sync Logs</button>&nbsp; -->

    <div class="columns">
      <div class="column is-3">
        <SelectBranch @triggerselectbranch="selectedBranch" />
      </div>
    </div>
    <button
      class="button is-info is-small"
      @click="viewEmployee"
      :disabled="branchId == 0"
    >
      View Employee
    </button>
    <div style="clear:both"></div>
    <br />
    <div class="columns">
      <div class="column is-4">
        <b-field label="Employee ID #" custom-class="is-small">
          <b-input
            type="text"
            size="is-small"
            v-model="employee.employeeIdNumber"
            disabled
          ></b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field label="Employee name" custom-class="is-small">
          <b-input
            type="text"
            size="is-small"
            v-model="employee.fullname"
            disabled
          ></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <b-field label="From" custom-class="is-small">
          <input
            type="date"
            v-model="dateFrom"
            class="input is-small"
            :disabled="employee.employeeIdNumber == null"
          />
        </b-field>
      </div>
      <div class="column is-4">
        <b-field label="To" custom-class="is-small">
          <input
            type="date"
            v-model="dateTo"
            class="input is-small"
            :disabled="employee.employeeIdNumber == null"
          />
        </b-field>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <div class="field is-grouped">
          <div class="control">
            <button
              class="button is-info is-small"
              @click="getTimesheetData"
              :disabled="!dateFrom || !dateTo"
            >
              Search</button
            >&nbsp;
            <button
              :class="buttonSave"
              @click="sendTimeSheetToEmployee"
              :disabled="!dateFrom || !dateTo"
            >
              Send timesheet to employee
            </button>
            &nbsp;
            <button
              :class="buttonDownloadPdf"
              @click="print"
              :disabled="!dateFrom || !dateTo"
            >
              Download PDF
            </button>
          </div>
          <!-- <div class="control">
        <button class="button is-default is-small" @click="resetTimesheetData">Reset</button>
      </div> -->
        </div>
      </div>
      <div class="level-right">
        <button
          class="button is-small is-success"
          :disabled="!dateFrom || !dateTo"
          @click="saveOptionChanges"
        >
          Save changes
        </button>
      </div>
    </div>
    <hr />
    <div
      class="notification is-danger"
      v-show="holidayPayValidation.length != 0"
    >
      <button
        class="delete"
        @click="closeHolidayPayValidationErrorMessage"
      ></button>
      <ul v-for="detail in holidayPayValidation" :key="detail.message">
        <li>{{ detail.message }}</li>
      </ul>
    </div>
    <div class="notification is-danger" v-show="errorMessage != ''">
      <button class="delete" @click="closeErrorMessage"></button>
      <center>{{ errorMessage }}</center>
    </div>
    <!-- Timesheet table -->
    <b-table
      :data="timeSheetData"
      :paginated="timeSheetIsPaginated"
      :per-page="timeSheetPerPage"
      :current-page.sync="timeSheetCurrentPage"
      :pagination-simple="timeSheetIsPaginationSimple"
      :default-sort-direction="timeSheetDefaultSortDirection"
      :loading="timeSheetIsLoading"
      default-sort="name"
    >
      <template slot-scope="{ row }">
        <b-table-column
          class="table-column-content-is-small"
          field="date"
          label="Date"
          sortable
          >{{ row.dateLog | dateFormat }}</b-table-column
        >
        <b-table-column
          class="table-column-content-is-small"
          field="checkIn"
          label="Check In"
          sortable
          >{{ row.checkIn | timeOnly }}</b-table-column
        >
        <b-table-column
          class="table-column-content-is-small"
          field="checkOut"
          label="Check Out"
          sortable
          >{{ row.checkOut | timeOnly }}</b-table-column
        >
        <b-table-column
          class="table-column-content-is-small"
          field="overtimeIn"
          label="Overtime In"
          sortable
          >{{ row.overtimeIn | timeOnly }}</b-table-column
        >
        <b-table-column
          class="table-column-content-is-small"
          field="overtimeOut"
          label="Overtime Out"
          sortable
          >{{ row.overtimeOut | timeOnly }}</b-table-column
        >
        <b-table-column
          class="table-column-content-is-small"
          field
          label
          centered
        >
          <button
            class="button is-warning is-small"
            @click="editTimeSheetData(row)"
          >
            Edit
          </button>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Option">
          <b-switch size="is-small" v-model="row.isIncludeOt"
            >Include OT</b-switch
          >
          &nbsp;
          <b-switch size="is-small" v-model="row.isIncludeHolidayPay"
            >Include Holiday Pay</b-switch
          >
          &nbsp;
          <div class="select">
            <select
              v-model="row.typeOfHoliday"
              :disabled="!row.isIncludeHolidayPay"
            >
              <option value="0">Regular holiday</option>
              <option value="1">Special Non-working holiday</option>
            </select>
          </div>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
    <!-- End Timesheet table -->
    <!-- Loading -->
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <!-- End Loading -->
    <!-- List of Employees -->
    <div
      class="modal"
      :class="viewEmployeeModalStatus | modalStatusFilter"
      v-show="branchId != 0"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">List of Employees</p>
          <button
            class="delete"
            aria-label="close"
            @click="viewEmployee"
          ></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          Selected Branch:
          <strong>{{ branchName }}</strong
          ><br />
          <table-pagination
            :tableData="employeeData.data"
            :bordered="true"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :mobileCards="true"
            :loading="isLoadingTable"
            :page="page"
            :perPage="perPage"
            :totalData="employeeData.totalData"
            @onPageChanged="page = $event"
            @onSearchChanged="search = $event"
            @onPerPageChanged="perPage = $event"
          >
            <template slot="row-content" slot-scope="{ item }">
              <b-table-column
                class="table-column-content-is-small"
                field="patientInitialVisitId"
                label="ID"
                >{{ item.row.employeeIdNumber }}</b-table-column
              >

              <b-table-column
                class="table-column-content-is-small"
                field="fullName"
                label="Name"
                >{{ item.row.fullname }}</b-table-column
              >

              <b-table-column field label="Actions" centered>
                <button
                  class="button is-primary is-small"
                  @click="select(item.row)"
                >
                  Select
                </button>
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                  </p>
                  <p>Nothing here.</p>
                </div>
              </section>
            </template>
          </table-pagination>
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button class="button is-small" @click="viewEmployee">Close</button>
        </footer>
      </div>
    </div>
    <edit-timesheet />
  </div>
</template>
<script>
import TablePagination from '../../components/TablePagination.vue'
import EditTimesheet from './EditTimesheet.vue'
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import SelectBranch from '../../components/Branch/SelectBranch'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      viewEmployeeModalStatus: false,
      editTimeSheet: false,
      branchId: 0,
      branchName: '',
      page: 1,
      perPage: 10,
      search: '',
      includeInactive: false,
      employee: {},
      dateFrom: null,
      dateTo: null,
      isLoading: false,
      isFullPage: true,
      timeSheetIsLoading: false,
      timeSheetData: [],
      timeSheetIsPaginated: true,
      timeSheetIsPaginationSimple: false,
      timeSheetDefaultSortDirection: 'asc',
      timeSheetCurrentPage: 1,
      timeSheetPerPage: 10,
      timeSheet: {},
      time: new Date(),
      apiHostAndPort: '',
      buttonSave: appButton.isLoadingNormal(false),
      buttonDownloadPdf: appButton.isLoadingNormal(false),
      errorMessage: '',
      holidayPayValidation: [],
      isSendingBulkTimesheet: "button is-small is-info"
    }
  },
  components: {
    TablePagination,
    EditTimesheet,
    SelectBranch
  },
  methods: {
    ...mapActions('employee', ['getPaginatedEmployees']),
    ...mapActions('timesheet', ['openEditModal']),
    default() {
      this.employee = {}
      this.dateFrom = null
      this.dateTo = null
    },
    closeHolidayPayValidationErrorMessage() {
      this.holidayPayValidation = []
    },
    closeErrorMessage() {
      this.errorMessage = ''
    },
    selectedBranch(branchInfo) {
      this.branchId = branchInfo.branchId ? branchInfo.branchId : 0
      this.branchName = branchInfo.branchName ? branchInfo.branchName : ''
      if (this.branchId == 0) {
        this.default()
      }
    },
    sendBulkTimesheets() {
      this.isSendingBulkTimesheet = "button is-small is-info is-loading"
      axios
        .get(`api/attendancelog/send-bulk-timesheets-to-employee`)
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => {
          if (error.response) {
            appToast.danger(error.response.data)
          }
        }).then(()=>{
          this.isSendingBulkTimesheet = "button is-small is-info"
        })
    },
    viewEmployee() {
      this.viewEmployeeModalStatus = !this.viewEmployeeModalStatus
    },
    select(data) {
      this.employee = data
      this.viewEmployee()
    },
    syncLogs() {
      this.isLoading = true
      axios
        .get(`api/attendancelog/sync`)
        .then(response => {
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
          this.isLoading = false
        })
    },
    saveAndGetTimeSheets(from, to, empId) {
      if (_.isEmpty(this.employee)) {
        this.$toast.open({
          duration: 5000,
          message: `Employee not found!`,
          position: 'is-bottom-right',
          type: 'is-danger'
        })
        return
      }
      if (from && to) {
        this.timeSheetIsLoading = true
        let timeSheet = {
          dateFrom: new Date(from).toDateString(),
          dateTo: new Date(to).toDateString(),
          empId: empId
        }
        this.errorMessage = ''
        axios
          .post(`api/AttendanceLog/timesheet`, timeSheet)
          .then(response => {
            this.timeSheetIsLoading = false
            this.timeSheetData = response.data.timesheet
          })
          .catch(error => {
            this.errorMessage = error.response.data
            this.timeSheetIsLoading = false
          })
      }
    },
    saveOptionChanges() {
      this.holidayPayValidation = []
      let timeSheetDetailWithOtAndHpDetail = []
      this.timeSheetData.forEach(data => {
        timeSheetDetailWithOtAndHpDetail = [
          {
            isIncludeId: data.isIncludeId,
            isIncludeOt: data.isIncludeOt,
            isIncludeHolidayPay: data.isIncludeHolidayPay,
            typeOfHoliday: data.typeOfHoliday,
            employeeId: data.employeeId,
            dateLog: data.dateLog
          },
          ...timeSheetDetailWithOtAndHpDetail
        ]

        // add validation
        if (data.isIncludeHolidayPay) {
          if (data.typeOfHoliday === null) {
            this.holidayPayValidation = [
              {
                message: `${moment(data.dateLog).format(
                  'MM/DD/YYYY'
                )} has checked the \"Include Holiday Pay\" option but the type is empty. Please select the type of leave.`
              },
              ...this.holidayPayValidation
            ]
          }
        }
      })
      if (this.holidayPayValidation.length == 0) {
        axios
          .put(
            `api/attendancelog/update-timesheet-with-ot-and-hp-detail`,
            timeSheetDetailWithOtAndHpDetail
          )
          .then(response => {
            appToast.success(response.data)
          })
          .catch(error => {
            appToast.danger(error.response.data)
          })
          .then(() => {
            this.holidayPayValidation = []
            this.getTimesheetData()
          })
      } else {
        return false
      }
    },
    editTimeSheetData(item) {
      this.openEditModal({
        showEditModal: true,
        timesheet: {
          id: item.id,
          employeeId: this.employee.employeeIdNumber,
          dateLog: moment(item.dateLog).format('YYYY-MM-DD'),
          checkIn: item.checkIn,
          checkOut: item.checkOut,
          overtimeIn: item.overtimeIn,
          overtimeOut: item.overtimeOut
        }
      })
    },
    getTimesheetData() {
      this.saveAndGetTimeSheets(
        this.dateFrom,
        this.dateTo,
        this.employee.employeeIdNumber
      )
    },
    resetTimesheetData() {
      let timeSheet = {
        dateFrom: new Date(this.dateFrom).toDateString(),
        dateTo: new Date(this.dateTo).toDateString(),
        empId: this.employee.employeeIdNumber
      }
      axios.post(`api/attendancelog/reset-ts`, timeSheet).then(
        response => {},
        err => {
          console.log(err)
        }
      )
    },
    async updateTs() {
      var body = {
        checkIn: moment(this.timeSheet.checkIn).format('YYYY-MM-DD hh:mm:ss'),
        checkOut: moment(this.timeSheet.checkOut).format('YYYY-MM-DD hh:mm:ss'),
        dateLog: new Date(this.timeSheet.dateLog).toDateString(),
        employeeId: this.employee.employeeIdNumber,
        overtimeIn: moment(this.timeSheet.overtimeIn).format(
          'YYYY-MM-DD hh:mm:ss'
        ),
        overtimeOut: moment(this.timeSheet.overtimeOut).format(
          'YYYY-MM-DD hh:mm:ss'
        ),
        hoursWorked: this.timeSheet.hoursWorked,
        oTHoursWorked: this.timeSheet.oThoursWorked,
        isOTPay: this.timeSheet.isOtPay,
        id: this.timeSheet.id
      }
      console.log(body)
      var ts = await axios.put(`api/AttendanceLog/update-ts`, body)
    },
    getApiHostAndPort() {
      axios
        .get(`api/settings/api-host-and-port`)
        .then(response => {
          this.apiHostAndPort = response.data
        })
        .catch(error => console.log(error))
    },
    print() {
      this.buttonDownloadPdf = appButton.isLoadingNormal(true)

      axios
        .get(
          `downloadables/timesheet?employeeId=${this.employee.employeeIdNumber}&dateFrom=${this.dateFrom}&dateTo=${this.dateTo}`,
          {
            responseType: 'blob'
          }
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `Timesheet of ${this.employee.fullname} - (${this.dateFrom}-${this.dateTo}).pdf`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonDownloadPdf = appButton.isLoadingNormal(false)
        })
    },
    sendTimeSheetToEmployee() {
      this.buttonSave = appButton.isLoadingNormal(true)
      const attendanceLogPeriodAndId = {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        empId: this.employee.employeeIdNumber
      }

      axios
        .post(
          `api/guestemployeetimesheets/send-timesheet-to-employee`,
          attendanceLogPeriodAndId
        )
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => console.log(error))
        .then(() => {
          this.buttonSave = appButton.isLoadingNormal(false)
        })
    }
  },
  computed: {
    ...mapState('employee', {
      employeeData: state => state.employees,
      isLoadingTable: state => state.isLoadingTable
    }),
    ...mapState('timesheet', {
      showEditModal: state => state.showEditModal
    })
  },
  created() {
    this.getPaginatedEmployees({
      branchId: this.branchId,
      page: this.page,
      pageSize: this.perPage,
      query: this.search,
      includeInactive: this.includeInactive
    })

    this.getApiHostAndPort()
  },
  watch: {
    branchId() {
      if (this.branchId != 0) {
        this.getPaginatedEmployees({
          branchId: this.branchId,
          page: this.page,
          pageSize: this.perPage,
          query: this.search,
          includeInactive: this.includeInactive
        })
      }
    },
    showEditModal() {
      if (!this.showEditModal) {
        // if false
        this.getTimesheetData()
      }
    },
    perPage(val) {
      this.getPaginatedEmployees({
        branchId: this.branchId,
        page: this.page,
        pageSize: val,
        query: this.search,
        includeInactive: this.includeInactive
      })
    },
    page(val) {
      this.getPaginatedEmployees({
        branchId: this.branchId,
        page: val,
        pageSize: this.perPage,
        query: this.search,
        includeInactive: this.includeInactive
      })
    },
    search(val) {
      this.getPaginatedEmployees({
        branchId: this.branchId,
        page: this.page,
        pageSize: this.perPage,
        query: val,
        includeInactive: this.includeInactive
      })
    },
    dateTo(val) {
      this.saveAndGetTimeSheets(
        this.dateFrom,
        val,
        this.employee.employeeIdNumber
      )
    }
  }
}
</script>
